import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

export const socialPlatformRequiredValidator: ValidatorFn = (
    control: AbstractControl
): ValidationErrors | null => {
  const isSubscribed = control.get("isSubscribedToDasp")?.value;
  if (!isSubscribed) return { subscribeTosocialRequired: true };

  const facebook =
      !!control.get("facebookAccount")?.value &&
      !!control.get("facebookLink")?.value;
  const instagram =
      !!control.get("instagramAccount")?.value &&
      !!control.get("instagramLink")?.value;

  return facebook || instagram ? null : { socialRequired: true };
};

